var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex mb-3"},[_c('h2',{staticClass:"text-body-1 flex-grow-1"},[(!!_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._t("default")],2),_c('h2',{staticClass:"text-body-1"},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }